"use client";

import React from "react";
import { Play, Mic, TrendingUp, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "ESTRATÉGIA",
  description: "Antes de produzir, entendemos seu negócio, público e objetivo para criar conteúdos que realmente geram resultado.",
  icon: Play
}, {
  title: "PRODUÇÃO",
  description: "Criamos vídeos e podcasts com qualidade profissional para posicionar sua marca com autoridade.",
  icon: Mic
}, {
  title: "DISTRIBUIÇÃO",
  description: "Aplicamos tráfego pago e estratégias digitais para transformar conteúdo em clientes.",
  icon: TrendingUp
}];
export default function OurExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222473" id="soluções-estratégicas" className="bg-background section w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mb-16 md:mb-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold text-3xl md:text-5xl text-foreground tracking-tight mb-4">Como transformamos conteúdo em clientes</h2>
          <div className="w-20 h-1.5 bg-primary rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
          const Icon = service.icon;
          const delay = index * 150;
          return <div key={index} data-index={index} className={`transition-all duration-700 ease-out fill-mode-both ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${delay}ms`
          }}>
                <Card className="relative h-full overflow-hidden border-border bg-background shadow-sm hover:shadow-xl hover:-translate-y-2 hover:border-primary transition-all duration-300 group/card rounded-xl">
                  <CardContent className="p-8 flex flex-col h-full">
                    <div className="relative mb-8 h-16 flex items-center">
                      <span className="absolute -left-4 -top-6 text-8xl font-default font-bold text-primary/5 select-none pointer-events-none transition-transform duration-500 group-hover/card:-translate-y-2 group-hover/card:text-primary/10">
                        0{index + 1}
                      </span>
                      <div className="relative z-10">
                        <Icon className="size-10 text-primary transition-transform duration-300 group-hover/card:scale-110" />
                      </div>
                    </div>

                    <div className="flex-grow">
                      <h3 className="font-default font-bold text-2xl mb-3 tracking-wide text-foreground uppercase">
                        {service.title}
                      </h3>
                      <p className="text-muted-foreground line-clamp-2 text-sm leading-relaxed mb-6">
                        {service.description}
                      </p>
                    </div>

                    {}
                    <div className="mt-auto pt-4 border-t border-border/40">
                      <Button variant="link" asChild className="p-0 h-auto text-primary font-semibold group/link hover:no-underline relative pr-5">
                        <Link to={index === 0 ? "https://itcmais.com/o-estudio/" : index === 1 ? "https://itcmais.com/estudio-de-podcast-em-pinheiros" : "https://itcmais.com/trafego-pago-para-empresas-que-querem-gerar-clientes"} newTab>
                          Saiba Mais
                          <ChevronRight className="size-4 absolute right-0 opacity-0 -translate-x-2 transition-all duration-300 group-hover/link:opacity-100 group-hover/link:translate-x-0" />
                        </Link>
                      </Button>
                    </div>

                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}